import React from "react";
import { useNavigate } from "react-router-dom";
import { usePatient } from "../../contexts"; // adjust path if needed
import { FiList, FiFileText } from "react-icons/fi";

const AllPatientsTable = ({ patients, toPatientServices }) => {
  const navigate = useNavigate();
  const {
    setPatientId,
    setPatientName,
    setHmoId,
    setPatientInfo,
    setHmoDetails,
  } = usePatient();

  const continueUpdate = (id, data) => {
    setPatientId(id);
    setPatientName(`${data?.firstName} ${data?.lastName}`);
    setHmoId(data?.hmoId);
    setPatientInfo(data);
    setHmoDetails(data);
    localStorage.setItem("patientId", id);
    localStorage.setItem("patientInfo", JSON.stringify(data));
    localStorage.setItem("patientName", `${data.firstName} ${data.lastName}`);
    navigate(`/doctor/patient-treatments/${id}`);
  };

  const goToTreatmentHistory = (id, data, e) => {
    e.stopPropagation();
    // Set context/localStorage if needed
    continueUpdate(id, data);
    navigate(`/doctor/patient-treatments/${id}`);
  };

  const goToCaseNotes = (id, data, e) => {
    e.stopPropagation();
    // Set context/localStorage if needed
    continueUpdate(id, data);
    navigate(`/doctor/patients/patient-details/${id}`);
    localStorage.setItem("appointmentId", null);
  };

  return (
    <div className="p-6 m-t-20">
      <div className="overflow-x-auto">
        <table
          style={{ backgroundColor: "white" }}
          className="min-w-full border table-auto w-full bg-white border border-gray-300 border-gray-200 rounded-md shadow-sm bordered-table"
        >
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 border">Ref</th>
              <th className="p-3 border">Name</th>
              <th className="p-3 border">Gender</th>
              <th className="p-3 border">DOB</th>
              <th className="p-3 border">Email</th>
              <th className="p-3 border">Phone</th>
              <th className="p-3 border">State</th>
              <th className="p-3 border">LGA</th>
              <th className="p-3 border">Action</th>
            </tr>
          </thead>
          <tbody>
            {patients.map((patient) => (
              <tr
                key={patient.id}
                className="hover:bg-gray-50"
                style={{ cursor: "pointer" }}
                onClick={() => continueUpdate(patient.id, patient)}
              >
                <td className="p-3 border">{patient.patientRef}</td>
                <td className="p-3 border">
                  {patient.firstName} {patient.lastName}
                </td>
                <td className="p-3 border">{patient.gender}</td>
                <td className="p-3 border">
                  {new Date(patient.dateOfBirth).toLocaleDateString()}
                </td>
                <td className="p-3 border">{patient.email}</td>
                <td className="p-3 border">{patient.phoneNumber}</td>
                <td className="p-3 border">{patient.stateOfOrigin}</td>
                <td className="p-3 border">{patient.lga}</td>
                <td className="p-3 border" style={{ display: "flex", gap: 12 }}>
                  <span
                    title="Treatment History"
                    style={{ cursor: "pointer" }}
                    onClick={(e) =>
                      goToTreatmentHistory(patient.id, patient, e)
                    }
                  >
                    <FiList size={18} />
                  </span>
                  <span
                    title="Case Notes"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => goToCaseNotes(patient.id, patient, e)}
                  >
                    <FiFileText size={18} />
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllPatientsTable;
